import React, { useMemo } from 'react';
import { MuiMarkdown, getOverrides } from 'mui-markdown';

import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Pre-compute base overrides at module level (constant result)
const baseOverrides = getOverrides({});

export default function SmallMuiMarkdown({ typographyProps, children }) {
  const overrides = useMemo(
    () => ({
      ...baseOverrides,
      h1: {
        component: Typography,
        props: {
          variant: 'h3',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      h2: {
        component: Typography,
        props: {
          variant: 'h4',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      h3: {
        component: Typography,
        props: {
          variant: 'h5',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      h4: {
        component: Typography,
        props: {
          variant: 'h6',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      h5: {
        component: Typography,
        props: {
          variant: 'body1',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      h6: {
        component: Typography,
        props: {
          variant: 'body1',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      p: {
        component: Typography,
        props: {
          variant: 'body1',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      span: {
        component: Typography,
        props: {
          variant: 'body1',
          gutterBottom: false,
          ...typographyProps,
        },
      },
      blockquote: {
        component: Typography,
        props: {
          gutterBottom: false,
          ...typographyProps,
        },
      },
      pre: {
        component: Typography,
        props: {
          gutterBottom: false,
          ...typographyProps,
        },
      },
      a: {
        component: Link,
        props: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    }),
    [typographyProps],
  );

  return <MuiMarkdown overrides={overrides}>{children}</MuiMarkdown>;
}
